import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Projects',
      type: 'table',
      content: {
        '{}': {
          noPagination: true,
          query: {
            '`': {
              filter: {
                '=': [
                  {
                    '@': 'projectAward',
                  },
                  {
                    '``': {
                      '@$': 'awardId',
                    },
                  },
                ],
              },
              target: 'ent:!projects:!proj',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'name',
                              },
                              recordId: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'code',
                              },
                              recordId: {
                                '@.': '!code',
                              },
                            },
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'descr',
                              },
                              recordId: {
                                '@.': '!descr',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                projectAward: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!projects#!proj:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!projects#!proj:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!projects#!proj:!descr',
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
}
